
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PreferenceReference,
  Preferences,
} from '../models';
import {
    PreferenceReferenceFromJSON,
    PreferenceReferenceToJSON,
    PreferencesFromJSON,
    PreferencesToJSON,
} from '../models';

export interface UpsertActivityAreaPreferencesRequest {
    preferences: Preferences;
}

export interface UpsertCompanySizePreferencesRequest {
    preferences: Preferences;
}

export interface UpsertDurationPreferencesRequest {
    preferences: Preferences;
}

/**
 * 
 */
export class MissionPreferencesApi extends runtime.BaseAPI {

    /**
     * Returns the list of activity area preferences for current user 
          */
    async getActivityAreaPreferencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Preferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Preferences>({
            path: `/profile/api/mission-preferences/activityarea`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PreferencesFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the list of activity area preferences for current user 
          */
    async getActivityAreaPreferences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Preferences> {
        const response = await this.getActivityAreaPreferencesRaw(initOverrides);
        return response._data;
    }

    /**
     * Returns the list of activity area values 
          */
    async getActivityAreaValuesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PreferenceReference>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<PreferenceReference>>({
            path: `/profile/api/mission-preferences/activityarea/values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(PreferenceReferenceFromJSON);
        return response;
    }

    /**
     * Returns the list of activity area values 
          */
    async getActivityAreaValues(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PreferenceReference>> {
        const response = await this.getActivityAreaValuesRaw(initOverrides);
        return response._data;
    }

    /**
     * Returns the list of company size preferences for current user 
          */
    async getCompanySizePreferencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Preferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Preferences>({
            path: `/profile/api/mission-preferences/companysize`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PreferencesFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the list of company size preferences for current user 
          */
    async getCompanySizePreferences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Preferences> {
        const response = await this.getCompanySizePreferencesRaw(initOverrides);
        return response._data;
    }

    /**
     * Returns the list of company size values 
          */
    async getCompanySizeValuesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PreferenceReference>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<PreferenceReference>>({
            path: `/profile/api/mission-preferences/companysize/values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(PreferenceReferenceFromJSON);
        return response;
    }

    /**
     * Returns the list of company size values 
          */
    async getCompanySizeValues(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PreferenceReference>> {
        const response = await this.getCompanySizeValuesRaw(initOverrides);
        return response._data;
    }

    /**
     * Returns the list of duration preferences for current user 
          */
    async getDurationPreferencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Preferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Preferences>({
            path: `/profile/api/mission-preferences/duration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PreferencesFromJSON(response._data); }
        return response;
    }

    /**
     * Returns the list of duration preferences for current user 
          */
    async getDurationPreferences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Preferences> {
        const response = await this.getDurationPreferencesRaw(initOverrides);
        return response._data;
    }

    /**
     * Returns the list of duration values 
          */
    async getDurationValuesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PreferenceReference>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<PreferenceReference>>({
            path: `/profile/api/mission-preferences/duration/values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(PreferenceReferenceFromJSON);
        return response;
    }

    /**
     * Returns the list of duration values 
          */
    async getDurationValues(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PreferenceReference>> {
        const response = await this.getDurationValuesRaw(initOverrides);
        return response._data;
    }

    /**
     * Upsert the list of activity area preferences for current user 
          */
    async upsertActivityAreaPreferencesRaw(requestParameters: UpsertActivityAreaPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['preferences'] == null) {
            throw new runtime.RequiredError(
                'preferences',
                'Required parameter "preferences" was null or undefined when calling upsertActivityAreaPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/mission-preferences/activityarea`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreferencesToJSON(requestParameters['preferences']),
        }, initOverrides);

        return response;
    }

    /**
     * Upsert the list of activity area preferences for current user 
          */
    async upsertActivityAreaPreferences(requestParameters: UpsertActivityAreaPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertActivityAreaPreferencesRaw(requestParameters, initOverrides);
    }

    /**
     * Upsert the list of company size preferences for current user 
          */
    async upsertCompanySizePreferencesRaw(requestParameters: UpsertCompanySizePreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['preferences'] == null) {
            throw new runtime.RequiredError(
                'preferences',
                'Required parameter "preferences" was null or undefined when calling upsertCompanySizePreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/mission-preferences/companysize`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreferencesToJSON(requestParameters['preferences']),
        }, initOverrides);

        return response;
    }

    /**
     * Upsert the list of company size preferences for current user 
          */
    async upsertCompanySizePreferences(requestParameters: UpsertCompanySizePreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertCompanySizePreferencesRaw(requestParameters, initOverrides);
    }

    /**
     * Upsert the list of duration preferences for current user 
          */
    async upsertDurationPreferencesRaw(requestParameters: UpsertDurationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['preferences'] == null) {
            throw new runtime.RequiredError(
                'preferences',
                'Required parameter "preferences" was null or undefined when calling upsertDurationPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/mission-preferences/duration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreferencesToJSON(requestParameters['preferences']),
        }, initOverrides);

        return response;
    }

    /**
     * Upsert the list of duration preferences for current user 
          */
    async upsertDurationPreferences(requestParameters: UpsertDurationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertDurationPreferencesRaw(requestParameters, initOverrides);
    }

}
